<template>
    <v-card class="mt-3">
        <v-toolbar color="primary" density="compact">
            <v-toolbar-title>{{ title }}</v-toolbar-title>
            <v-toolbar-items>
                <v-btn
                    v-if="canEdit"
                    size="large"
                    elevation="0"
                    @click="openFileDialog"
                    :disabled="documents.length >= maxDocuments"
                >
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
            <v-row>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="6"
                    xl="4"
                    v-for="(doc, index) in documents"
                    :key="doc.id"
                >
                    <DocumentCard
                        :canEdit="canEdit"
                        :doc="doc"
                        :index="index"
                        @delete="deleteDocument(doc.id)"
                    />
                </v-col>
            </v-row>
        </v-card-text>

        <v-file-input
            ref="fileInput"
            v-model="newFiles"
            multiple
            style="display: none"
            accept="application/pdf"
            @change="uploadFiles"
        />
    </v-card>
</template>

<script>
import DocumentCard from "@/components/display/DocumentCard.vue";
import axios from "axios";
import { showAlertModal } from "@/utils";

export default {
    name: "DocumentManager",
    components: { DocumentCard },
    props: {
        documents: Array,
        uploadUrl: String,
        deleteUrlPrefix: String,
        title: {
            type: String,
            default: "Documents",
        },
        maxDocuments: {
            type: Number,
            default: 10,
        },
        onUpload: Function,
        onDelete: Function,
        canEdit: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            newFiles: [],
        };
    },
    methods: {
        showAlertModal,
        openFileDialog() {
            this.$refs.fileInput.click();
        },
        async uploadFiles() {
            if (!this.newFiles.length) return;
            const formData = new FormData();
            this.newFiles.forEach((file) => formData.append("documents", file));

            try {
                await axios.post(this.uploadUrl, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                this.onUpload?.();
            } catch (error) {
                console.error("Upload error:", error);
                this.showAlertModal(
                    this.$store,
                    this.$t("company.uploadFailed"),
                    "danger",
                    12000,
                    error
                );
            } finally {
                this.newFiles = [];
            }
        },
        async deleteDocument(docId) {
            if (!confirm(this.$t("company.confirmDeleteDocument"))) return;

            try {
                await axios.delete(`${this.deleteUrlPrefix}/${docId}/`);
                this.onDelete?.();
            } catch (error) {
                console.error("Delete error:", error);
                this.showAlertModal(
                    this.$store,
                    this.$t("company.deleteFailed"),
                    "danger",
                    12000,
                    error
                );
            }
        },
    },
};
</script>
